// Screenname:DeliveryTerms master
// Developer Name: Jagadish.
// Created date on: 2 / 2 / 2023
// Comments and Suggestions:
// TS File: Service
// Messages:
import httpbaseURL from "../../../../modules/Inventory/common/axios";
class AgreementMasterServices {
  createdata(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/AgreementMaster/Create", doc);
  }
  getdata() {
    return httpbaseURL.httpMSInventoryUrl.get("/AgreementMaster/ListAgreement");
  }
  getfindonedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.get("/AgreementMaster/Get?id=" + doc);
  }

  getAssetByGRNId(doc) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AgreementMaster/GetAssetByGRNId?GRNId=" + doc
    );
  }

  listAssetByItemId(doc) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AgreementMaster/ListAssetByItemId?ItemId=" + doc
    );
  }
  //asset details fetch
  getItemDetailsByAssetId(doc) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AgreementMaster/GetItemDetailsByAssetId?AssetId=" + doc
    );
  }

  updatedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.post(
      "/AgreementMaster/UpdateCustom",
      doc
    );
  }
  updateStatus(doc) {
    return httpbaseURL.httpMSInventoryUrl.post(
      "/AgreementMaster/UpdateStatus",
      doc
    );
  }
  deletedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.delete(
      "/AgreementMaster/Delete?id=" + doc
    );
  }
  active(DelID, Status) {
    debugger;
    return httpbaseURL.httpMSInventoryUrl.put(
      "AgreementMaster/Active?id=" + DelID + "&Status=" + Status + ""
    );
  }
}
export default new AgreementMasterServices();
